import { Injectable } from '@angular/core';
import { ApiService } from '@workflow/ecp-shared/service/api/api.service';
import { Observable } from 'rxjs';
import { LoansStatus } from 'src/shared/enum';
import { LDRLoan } from '../consts/ldr-data.const';
import { CollateralDetail } from '../models/application.model';
import { StatefulService } from '@app/service/stateful.service';

/**
 * Service representing consumer loan service section
 * @Service
 */
@Injectable({
  providedIn: 'root'
})
export class ConsumerLoanService {
  constructor(private readonly apiService: ApiService, private readonly statefulService: StatefulService) {}

  /**
   * Function used to get auto image
   */
  public GetAutoImage(
    vin: string,
    dealerCode: string,
    model: string,
    year: string,
    condition: string,
    make: string
  ): Observable<CollateralDetail> {
    return this.apiService.request({
      body: {
        dealerCode,
        vin,
        model,
        year,
        make,
        trim: condition
      },
      urlObj: LDRLoan.GetAutoImage
    });
  }

  /**
   * Function for funded loan status
   */
  public isFundedLoan(loanStatus: string): boolean {
    // check if loan is approved, pre-approved or conditionally approved
    if (loanStatus.toLowerCase() === LoansStatus.Funded) {
      return true;
    }
    return false;
  }
}
